import React, { useState, useEffect } from 'react';
import Box from '../../molecules/Box';
import Select from '@material-ui/core/Select';
import useStyles from './style';
import Picture from '../../atoms/Picture';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '../../atoms/Typography';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import Breadcrumb from '../../../containers/common/Breadcrumb';
import { get } from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import aspectRatios from '../../../utils/AspectRatios';
import { SHOW_BREADCRUMB_ON_Banner_AD_Calendar } from '../../../../constants';

const ADListing = props => {
  const vadMain = get(
    props,
    'props.sitecoreContext.route.placeholders.vad-main',
    []
  );
  const heading = get(props, 'props.titleHeading', '');
  // get object with componentName="tickets" from ticketsData
  const theme = useTheme();
  const isRTL = theme && theme.direction === 'rtl';
  const ticketsData = get(
    vadMain,
    vadMain.findIndex(item => item.componentName === 'Breadcrumb'),
    0
  );

  const breadCrumbData = get(ticketsData, 'fields.customContentList', []);
  const showBreadCrumb = get(ticketsData, 'params.style', '') === SHOW_BREADCRUMB_ON_Banner_AD_Calendar;

  props = { ...props, fields: { customContentList: breadCrumbData } };

  const { adCalendarItems } = props
  const classes = useStyles();

  const [selectedEvent, setSelectedEvent] = useState(adCalendarItems[0].fields);

  const handleChange = event => {
    const selectedTitle = event.target.value;
    const selected = adCalendarItems.find(
      ({ fields }) => fields.Title.value === selectedTitle
    );
    setSelectedEvent(selected.fields);
    props.renderEventHandler('TopBanner', {
      key: 'eventcategories',
      value: selected.fields.SearchKey.value,
    });
  };

  useEffect(() => {
    if (props.shouldResetFilter)
      setSelectedEvent(adCalendarItems[0].fields);
  }, [props.shouldResetFilter]);

  useEffect(() => {
    if (props.selectedInitialValue) {
      const intialValues = props.selectedInitialValue.value || []
      const found = adCalendarItems.find(({ fields }) => (fields.SearchKey.value === intialValues.join(',')) || (fields.SearchKey.value === intialValues.reverse().join(',')))
      if (found) setSelectedEvent(found.fields)
    }
  }, [props.selectedInitialValue])

  const CustomMenuProps = {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: isRTL ? 'right' : 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: isRTL ? 'right' : 'left',
    },
    getContentAnchorEl: null,
    classes: {
      paper: classes.CustomMenuProps,
    },
  };

  return (
    <>
      <Box
        component="div"
        className={classes.root}
        key={selectedEvent.Title.value}
      >
        <Picture
          isParalax={false}
          media={{
            image: selectedEvent.bgImage,
            aspectRatio: aspectRatios['5x2'],
          }}
        />
        <Box className={classes.adListingContainer}>
          {showBreadCrumb && <Breadcrumb {...props} />}
          <Select
            className={classes.adListingOptionsContainer}
            value={selectedEvent.Title.value}
            onChange={handleChange}
            MenuProps={CustomMenuProps}
          >
            {adCalendarItems.map(({ fields }, i) => (
              <MenuItem
                className={classes.adListingOptions}
                key={i}
                value={fields.Title.value}
              >
                {fields.Title.value}
              </MenuItem>
            ))}
          </Select>
          <Typography variant={'h1'} className={classes.adListingSpan}>
            {heading}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default ADListing;
